import Constants from './constants';

class UrlFactory {
    constructor() {
        this.apiUrl = Constants.ENVIRONMENT['DEVELOPMENT'];
        this.clockoutApiUrl = Constants.ENVIRONMENT['CLOCKOUT_STAGING_API'];   
    }

    createContextUrl() {
        return `/context`;
    }
    
    createFiUrl(aba) {
        return `https://${this.clockoutApiUrl}/api/consumer/fi/${aba}`;
    }
}

export default UrlFactory;
